export * from './baMultiCheckbox.component'



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMultiCheckbox/index.ts